import _ from "lodash";
import React, { memo } from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { ModalService, useMobileScreenCheck } from "../../../modal";
import { MobileActionDialog } from "../../../mobileActionDialog";
import { useHeaderTableContext } from "../headerContextProvider";

import "./MobileSort.scss";

const sortingClasses = (desc, showSortingArrows = true) =>
  classnames({
    sorted: showSortingArrows,
    "sorted--asc": !_.isUndefined(desc) && !desc,
    "sorted--desc": desc,
  });

export const MobileSort = memo(function MobileSort() {
  const { getMobileSortProps } = useHeaderTableContext();
  const { allColumns, toggleSortBy, sortBy } = getMobileSortProps();

  const accessors = _.map(allColumns, ({ id, SortingLabel }) => ({
    id,
    SortingLabel,
    desc:
      !_.isEmpty(sortBy) && _.some(sortBy, { id: id })
        ? sortBy[0].desc
        : undefined,
  }));

  //If table dont have default sorting in initial state we need to take just first column accessor
  const currentAccessor = _.isEmpty(sortBy)
    ? accessors[0]
    : _.find(accessors, { id: sortBy[0].id });

  return (
    <button
      type="button"
      className={classnames(
        "mobile-sorting__btn",
        sortingClasses(currentAccessor.desc)
      )}
      onClick={() =>
        openModal(accessors, currentAccessor)
          //toggleSortBy(ColumnId: String, descending: Bool, isMulti: Bool)
          .then(({ id }) => toggleSortBy(id))
          .catch(() => null)
      }
      data-testid="sorting-button"
    >
      {currentAccessor.SortingLabel}
    </button>
  );
});

const openModal = (accessors, currentAccessor) =>
  ModalService.show((modal) => ({
    dialog: (
      <SortByDialog
        accessors={accessors}
        currentAccessor={currentAccessor}
        modal={modal}
      />
    ),
  }));

export const SortByDialog = ({ accessors, modal }) => {
  const collapse = () => modal.reject();

  useMobileScreenCheck(collapse);

  const items = accessors.map((item) => ({
    onClick: () => modal.resolve({ id: item.id }),
    className: sortingClasses(item.desc, !_.isUndefined(item.desc)),
    content: item.SortingLabel,
    id: item.id,
  }));

  return (
    <MobileActionDialog
      headerText={<FormattedMessage id="sort_by" />}
      items={items}
      onClose={collapse}
    />
  );
};
